import { PButton, PCrest, PTabsBar } from '@porsche-design-system/components-react';
import { memo, useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const routes = ['/', '/epicmap'];

export const NavigationBar = memo(({ onExpandAll, onCollapseAll, onRefresh }) => {
  const [tabIndex, setTabIndex] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const onUpdate = useCallback(
    (e) => {
      const index = e.detail.activeTabIndex;

      console.log('routesIndex: ', routes[index]);
      if (routes[index]) {
        navigate(routes[index]);
      }
      setTabIndex(index);
    },
    [navigate]
  );

  useEffect(() => {
    // Set tabIndex based on current route after refresh
    const index = routes.indexOf(location.pathname);
    if (index !== -1) {
      setTabIndex(index);
    }
  }, [location.pathname]);

  return (
    <nav className="relative flex items-center justify-between h-16 px-8">
      {/* Tabs */}
      <div className="flex items-center">
        <PTabsBar activeTabIndex={tabIndex} onUpdate={onUpdate}>
          <button>Feature Map</button>
          <button>Epic Map</button>
        </PTabsBar>
      </div>

      {/* Porsche Logo */}
      <div className="flex absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <PCrest
          href="https://porsche.com"
          aria={{ 'aria-label': 'Porsche Homepage' }}
          style={{ padding: '16px' }}
        />
      </div>

      {/* Right buttons */}
      <div className="flex items-center space-x-4">
        <PButton
          variant="ghost"
          hideLabel={true}
          compact={true}
          iconSource={'/collapse-all.svg'}
          onClick={onCollapseAll}
        />
        <PButton
          variant="ghost"
          hideLabel={true}
          compact={true}
          iconSource={'/expand-all.svg'}
          onClick={onExpandAll}
        />
        <PButton
          variant="ghost"
          hideLabel={true}
          icon="refresh"
          compact="true"
          onClick={onRefresh}
        />
      </div>
    </nav>
  );
});
